import React from "react";
import {TranslationDomainEnum} from "../../../types/enums";
import {Checkbox, Form} from "antd";
import {Translate} from "../../../components/util/translation.util";

type Props = {
    name: string,
    label: string,
    translationDomain: TranslationDomainEnum,
    rules: any,
    onChange?: () => void,
    errors: { [key: string]: string[] },
    validateTrigger?: string,
}

export const CheckboxType: React.FC<Props> = ({ name, label, translationDomain, rules, errors, onChange,validateTrigger= 'onBlur' }) => {
    return (
        <Form.Item
                labelAlign={`left`}
                valuePropName={'checked'}
                name={ name.split('.') }
                label={<Translate message={label} domain={translationDomain} />}
                htmlFor={name}
                rules={rules}
                validateTrigger={validateTrigger}
        >
            <Checkbox id={name} />
        </Form.Item>
    )
}